/**
 * SkipLinks - WCAG 2.4.1 Bypass Blocks
 *
 * BYK-167: Accessibility features
 * Provides keyboard-accessible skip links for main content areas.
 * Links become visible on focus for sighted keyboard users.
 */

import { cn } from "@/lib/utils";

export interface SkipLinksProps {
  /** Custom class name */
  className?: string;
}

export function SkipLinks({ className }: SkipLinksProps) {
  return (
    <div className={cn("fixed left-0 top-0 z-[100]", className)}>
      {/* Skip to main content */}
      <a
        href="#main-canvas"
        className={cn(
          // sr-only: accessible to screen readers but visually hidden
          // focus:not-sr-only: visible when focused (WCAG 2.4.1 compliant)
          "sr-only focus:not-sr-only",
          "focus:absolute focus:left-2 focus:top-2 focus:z-[100]",
          "rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white shadow-lg",
          "focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2"
        )}
      >
        Skip to canvas
      </a>

      {/* Skip to left sidebar */}
      <a
        href="#left-sidebar"
        className={cn(
          "sr-only focus:not-sr-only",
          "focus:absolute focus:left-2 focus:top-14 focus:z-[100]",
          "rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white shadow-lg",
          "focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2"
        )}
      >
        Skip to create tools
      </a>

      {/* Skip to right sidebar */}
      <a
        href="#right-sidebar"
        className={cn(
          "sr-only focus:not-sr-only",
          "focus:absolute focus:left-2 focus:top-24 focus:z-[100]",
          "rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white shadow-lg",
          "focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2"
        )}
      >
        Skip to properties
      </a>
    </div>
  );
}

export default SkipLinks;
